import React, { useState } from "react";
import api from "../api";
import { Search, Pencil } from "lucide-react";

export default function BuscarEmpleado({ onEditar }) {
  const [documento, setDocumento] = useState("");
  const [empleado, setEmpleado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleBuscar = async () => {
    if (!documento.trim()) {
      setErrorMsg("⚠️ Ingresa un número de documento para buscar.");
      setEmpleado(null);
      return;
    }

    setLoading(true);
    setErrorMsg("");

    try {
      console.log(`Buscando empleado con documento: ${documento}`);
      const response = await api.get(`/empleados/buscar/${documento}`);

      console.log("Empleado encontrado:", response.data);
      setEmpleado(response.data);
      setErrorMsg("");
    } catch (error) {
      console.error("❌ Error al buscar empleado:", error.response ? error.response.data : error.message);
      setEmpleado(null);
      setErrorMsg("Empleado no encontrado o error en la búsqueda.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-2xl shadow-lg">
      <h2 className="text-2xl font-bold mb-4">🔍 Buscar empleado</h2>

      {/* Buscador */}
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          placeholder="Número de documento"
          value={documento}
          onChange={(e) => setDocumento(e.target.value)}
          className="border rounded-lg p-2 flex-grow"
        />
        <button
          onClick={handleBuscar}
          disabled={loading}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-white ${
            loading ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          <Search size={18} />
          {loading ? "Buscando..." : "Buscar"}
        </button>
      </div>

      {/* Mensaje de error */}
      {errorMsg && (
        <div className="bg-red-100 text-red-700 p-2 rounded mb-3">{errorMsg}</div>
      )}

      {/* Resultado */}
      {empleado && (
        <div className="border rounded-lg p-4 bg-gray-50 shadow-sm">
          <h3 className="text-lg font-semibold mb-2">
            {empleado.nombre} {empleado.apellido}
          </h3>
          <p><strong>Documento:</strong> {empleado.numero_documento}</p>
          <p><strong>Correo:</strong> {empleado.correo}</p>
          <p><strong>Cargo:</strong> {empleado.cargo?.nombre || empleado.cargo || "N/A"}</p>
          <p><strong>Departamento:</strong> {empleado.departamento?.nombre}</p>
          <p><strong>Estado:</strong>{" "}
            {empleado.activo ? (
              <span className="text-green-600 font-semibold">Activo</span>
            ) : (
              <span className="text-red-600 font-semibold">Inactivo</span>
            )}
          </p>

          <div className="mt-4 flex justify-end">
            <button
              onClick={() => onEditar(empleado)}
              className="flex items-center gap-2 px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded-lg"
            >
              <Pencil size={18} /> Editar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
